import { Card, Box, Skeleton } from "@mui/material";

interface DriverCardSkeletonProps {
  animationDelay?: number;
}

function DriverCardSkeleton({ animationDelay = 0 }: DriverCardSkeletonProps) {
  return (
    <Card
      sx={{
        padding: 2,
        border: (theme) => `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        animation: "fadeInUp 400ms cubic-bezier(0.4, 0, 0.2, 1) backwards",
        animationDelay: `${animationDelay}ms`,
        "@keyframes fadeInUp": {
          from: {
            opacity: 0,
            transform: "translateY(20px)",
          },
          to: {
            opacity: 1,
            transform: "translateY(0)",
          },
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 1 }}>
        <Skeleton variant="text" width="60%" height={32} animation="wave" />
        <Skeleton variant="rounded" width={80} height={24} animation="wave" />
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1, marginBottom: 2 }}>
        <Skeleton variant="text" width={80} height={20} animation="wave" />
        <Skeleton variant="rounded" sx={{ flexGrow: 1 }} height={40} animation="wave" />
      </Box>

      <Box sx={{ display: "flex", gap: 1, marginBottom: 2 }}>
        <Skeleton variant="rounded" sx={{ flex: 1 }} height={36} animation="wave" />
        <Skeleton variant="rounded" sx={{ flex: 1 }} height={36} animation="wave" />
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
        <Skeleton variant="text" width="45%" height={20} animation="wave" />
        <Skeleton variant="text" width="45%" height={20} animation="wave" />
      </Box>
    </Card>
  );
}

export default DriverCardSkeleton;
